import React from "react"
import { useHistory } from "react-router-dom"
import { FaShoppingCart } from "react-icons/fa"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { deliveryTypeLabels } from "constant"
import { isDirectionLtr, thousandSeparator } from "utils"
import { Button, IconButton } from "components"
import classes from "./index.module.scss"

const KfFooter = () => {
  const history = useHistory()

  const [t] = useTranslation()

  const { cinemaSolonNumber, deliveryType } =
    useSelector(state => state.deliveryInfo)

  const order =
    useSelector(state => state.order)

  const handleNavigate = () => {
    if (disabled) return

    history.push("/kiosk-checkout")
  }

  const handleGoToCinemaSolons = () => {
    history.push(
      "/kiosk-cinema-solons",
      { redirectFrom: "/kiosk-foods" }
    )
  }

  const handleGoToDeliveryType = () => {
    history.push(
      "/kiosk-delivery-types",
      { redirectFrom: "/kiosk-foods" }
    )
  }

  const numberOfOrderItems =
    order.items.reduce((to, item) =>
      to += !item.isExtra ? item.quantity : 0
      , 0
    )

  const numberOfComboItems =
    order.combos.reduce((t, combo) =>
      t += combo.items.reduce((to, item) =>
        to += item.quantity
        , 0
      )
      , 0
    )

  const subTotalOrderItems =
    order.items.reduce((to, item) =>
      to += item.salePrice * item.quantity
      , 0
    )

  const subTotalCombos =
    order.combos.reduce((t, combo) =>
      t += combo.comboSetSalePrice
      , 0
    )

  const subTotal =
    subTotalOrderItems +
    subTotalCombos

  const totalItems =
    numberOfOrderItems + numberOfComboItems

  const isLtr = isDirectionLtr()

  const disabled = totalItems === 0

  return (
    <div className={classes["container"]}>
      <div className={classes["right"]}>
        <div className={classes["delivery-type"]}>
          {t("نوع_سفارش")}:

          <Button
            className={classes["button"]}
            onClick={handleGoToDeliveryType}
            color="info"
          >
            {t(deliveryTypeLabels[deliveryType])}
          </Button>
        </div>

        {
          deliveryType === "cinema" &&
          <div className={classes["delivery-type"]}>
            {t("نام_سینما")}:

            <Button
              className={classes["button"]}
              onClick={handleGoToCinemaSolons}
              color="info"
            >
              {t(cinemaSolonNumber)}
            </Button>
          </div>
        }
      </div>

      <div className={classes["left"]}>
        <div
          className={clsx(
            classes["total"],
            isLtr && classes["total-ltr"]
          )}
        >
          {thousandSeparator(subTotal)}
        </div>

        <div
          onClick={handleNavigate}
          className={clsx(
            classes["view"],
            disabled && classes["disabled"]
          )}
        >
          <IconButton
            badge={totalItems}
            icon={FaShoppingCart}
            color="white"
            badgeClassName={classes["badge"]}
            size={30}
          />

          <span
            className={clsx(
              classes["text"],
              isLtr && classes["text-ltr"]
            )}
          >
            {t("مشاهده_سبد_خرید")}
          </span>
        </div>
      </div>
    </div>
  )
}

export default KfFooter